import gql from 'graphql-tag';

export const UPDATE_JOB_CUSTOMER = gql(`
    mutation($jobId: Uuid!, $customerId: Uuid!) {
        updateJobCustomer(jobId: $jobId, customerId: $customerId)
    }
`);

export const UPDATE_JOB_CUSTOMER_DETAILS = gql(`
    mutation ($jobId: Uuid!, $model: UpdateJobCustomerDetailsModelInput!) {
        updateJobCustomerDetails(jobId: $jobId, model: $model)
    }
`);
